import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2, RefreshCw, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ReturnChecksTable } from '@/components/processingJo/ReturnChecksTable';
import { joApi, joErr } from '@/services/processingJoApi';

const TABS = [['PENDING', 'Waiting'], ['APPROVED', 'Approved'], ['REJECTED', 'Rejected'], ['', 'All']];

export default function InhouseReturnChecks() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('PENDING');
  const [data, setData] = useState(null);
  const load = useCallback(() => joApi.returnChecks({ status: tab || undefined }).then(setData)
    .catch((e) => toast.error(joErr(e, 'Could not load return checks'))), [tab]);
  useEffect(() => { setData(null); load(); }, [load]);

  return (
    <div className="min-h-screen bg-[#FFFBF5]" data-testid="return-checks-page">
      <header className="bg-[#1A1F2E] pt-10 text-white shadow-lg sm:pt-0">
        <div className="mx-auto flex h-16 max-w-7xl items-center gap-3 px-4 md:px-6">
          <Button variant="ghost" onClick={() => navigate('/sections/inhouse')} className="text-white hover:bg-white/10" data-testid="rc-back-btn"><ArrowLeft className="h-5 w-5" /></Button>
          <ShieldCheck className="hidden h-6 w-6 text-amber-400 sm:block" />
          <div className="min-w-0"><h1 className="truncate text-lg font-bold sm:text-xl">Job Order Return Checks</h1>
            <p className="hidden text-xs text-[#E8DCC8] sm:block">Returned job-order bundles with more pieces than sent, another sort no or colour</p></div>
          <Button variant="outline" onClick={load} className="ml-auto border-white/30 bg-transparent text-white hover:bg-white/10" data-testid="rc-refresh-btn"><RefreshCw className="h-4 w-4" /></Button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl space-y-4 px-4 py-6 md:px-6">
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex rounded-md border bg-white p-0.5" data-testid="rc-tabs">
            {TABS.map(([v, l]) => <button key={l} type="button" onClick={() => setTab(v)} data-testid={`rc-tab-${l.toLowerCase()}`}
              className={`rounded px-3 py-1.5 text-sm transition-colors ${tab === v ? 'bg-[#1A1F2E] text-white' : 'text-gray-600 hover:bg-gray-100'}`}>
              {l}{v === 'PENDING' && data?.pending_count ? ` (${data.pending_count})` : ''}</button>)}
          </div>
          {data && !data.can_approve && <p className="text-xs text-gray-500" data-testid="rc-view-only">Only a Supervisor, In-charge or Admin can approve or reject.</p>}
        </div>
        <Card className="border-0 shadow-md"><CardContent className="overflow-x-auto p-0">
          {!data ? <Loader2 className="mx-auto my-12 h-6 w-6 animate-spin text-[#2D5F4F]" />
            : <ReturnChecksTable rows={data.rows} canApprove={data.can_approve} onChanged={load} />}
        </CardContent></Card>
      </main>
    </div>
  );
}
